module.exports = __webpack_public_path__ + "static/source-train-5cb5c4478b2e2bfe162ec5f0d04fbbca.svg";